export const setSystemData = async (key: string, data: string) => {
    localStorage.setItem(key, data)
}

export const getSystemData = async (key: string) => {
    return localStorage.getItem(key)
}